<h2 mat-dialog-title>Deportistas</h2>
<mat-dialog-content>
<div style="width: 100%; padding: 10px;">
  <div>
    <span>Saldo:</span><span>{{ saldo | currency: "":"symbol":"1.0-0" }}</span>
  </div>

  <div>
    <span>Valor orden:</span
    ><span>{{ valOrdenTmp | currency: "":"symbol":"1.0-0" }}</span>
  </div>
</div>
  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre o Número de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" 
    class="w-full md:w-auto"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Disciplina</mat-label>
      <mat-select
        [(ngModel)]="disciplinaSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option
          *ngFor="let disciplinaTmp of lstDisciplinas"
          [value]="disciplinaTmp.id"
        >
          {{ disciplinaTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" 
    class="w-full md:w-auto"
    style="padding-left: 10px; font-size: smaller"
  >
    <mat-label>Filtrar deportistas</mat-label>
    <mat-select
      [(ngModel)]="filtroSelect"
      (selectionChange)="cambioDiscipinaBuscar()"
    >
      <mat-option value="0"> Todos los deportistas</mat-option>
      <mat-option value="1"> Deportistas con fecha fin servicio caducada</mat-option>
      <mat-option value="2"> Deportistas sin orden de compra en el mes ({{mesActual}})</mat-option>
    </mat-select>
  </mat-form-field>

  <button
  style="margin-left: 10px"
  (click)="onEnter()"
  mat-raised-button
  color="primary"
>
  Buscar
</button>


  </div>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z1 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.nombre }}          
          <mat-icon 
          *ngIf="!element.conHorarios"
          matTooltip="Usuario sin horarios"
          matTooltipPosition="after" 
          color="warn"
          style="cursor: pointer;"
          > warning </mat-icon>

          <mat-icon 
          *ngIf="!element.conFoto"
          matTooltip="Usuario sin foto"
          matTooltipPosition="after" 
          color="warn"
          style="cursor: pointer;"
          > no_photography </mat-icon>


          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

       <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha Fin Ingreso</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaHasta | date: 'dd-MM-yyyy' }}</td>
      </ng-container> 

      <ng-container matColumnDef="plan">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let element">

          <mat-form-field  appearance="outline" class="example-full-width">
          <mat-select [value]="element?.planId+''" (selectionChange)="cambioPlan($event.value,element)" >
            <mat-option value="">Sin plan</mat-option>
            <mat-option
            *ngFor="let planTmp of lstPlanes"
            [value]="planTmp.id"
          >
            {{ planTmp.nombre }}
          </mat-option>

          </mat-select>
      
          </mat-form-field>


        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Asignado</th>
        <td mat-cell *matCellDef="let element" style="text-align: center">
          <mat-slide-toggle [disabled]="!element.planId"
            [checked]="element.estado"
            (change)="onToggle($event, element)"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef>Comentario</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="accent" (click)="comentario(element)" [disabled]="!element.estado" >
            <mat-icon>note_alt</mat-icon>
          </button>
        </td>
      </ng-container> 

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100, 150, 500]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Aceptar</button>
</mat-dialog-actions>
